<template>
  <div class="action-dialog">
    <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" :before-close="handleClose">
      <div class="action-dialog-body">
        <div v-if="icon" class="icon-container" :class="type" icon="el-icon-warning">
          <i class="el-icon-warning"></i>
        </div>
        <div class="message-container">
          <p v-if="dangerouslyUseHTMLString" v-html="message"></p>
          <p v-if="!dangerouslyUseHTMLString">{{ message }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="footer-block footer-left">
          <slot name="footer-left" />
        </div>
        <div class="footer-block footer-right">
          <el-button @click="handleAction('cancel')">{{ cancelButtonText || i18n.t('common.cancel') }}</el-button>
          <el-button type="primary" @click="handleAction('confirm')">
            {{ confirmButtonText || i18n.t('common.confirm') }}
          </el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import i18n from '@/i18n';
export default {
  props: {
    callback: {
      type: Function,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    cancelButtonText: String,
    confirmButtonText: String,
    dangerouslyUseHTMLString: {
      type: Boolean,
      default: false
    },
    width: String
  },
  data() {
    return {
      dialogVisible: true,
      i18n
    };
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'warning':
          return 'el-icon-warning';
        case 'info':
          return 'el-icon-info';
        default:
          return '';
      }
    }
  },
  methods: {
    handleAction(action) {
      if (action === 'confirm' || action === 'cancel') {
        this.dialogVisible = false;
      }
      setTimeout(() => {
        this.callback(action, this);
      });
      this.$emit('action', action);
    },
    handleClose(done) {
      this.handleAction('close');
      done();
    }
  }
};
</script>
<style lang="scss">
.action-dialog {
  .el-dialog__body {
    padding: 10px 15px;
  }
}
</style>
<style lang="scss" scoped>
.action-dialog {
  .action-dialog-body {
    position: relative;
    .icon-container {
      position: absolute;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      font-size: 24px !important;
      display: inline-block;
      &.warning {
        color: #e6a23c;
      }
      & + .message-container {
        padding-left: 36px;
        padding-right: 12px;
      }
    }
    .message-container {
      p {
        line-height: 24px;
      }
    }
  }
  .footer-left {
    float: left;
  }
}
</style>
